module.exports = __webpack_public_path__ + "static/media/audience1.43e2ae74.jpg";